import { createTheme, responsiveFontSizes } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5252ff",
    },
    secondary: {
      main: "#477BA1",
    },
    success: {
      main: "#08a33c",
    },
  },
  typography: {
    fontFamily: ["Mukta", "sans-serif"].join(","),

    h1: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontWeight: 600,
    },
    h2: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontWeight: 600,
    },
    h3: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontWeight: 600,
    },
    h4: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontWeight: 600,
    },
    h5: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontWeight: 400,
    },
    h6: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontSize: "18px",
      color: "#000",
      fontWeight: 400,
    },
    caption: {
      fontFamily: ["Mukta", "sans-serif"].join(","),
      fontWeight: 100,
      color: "#808080",
    },
  },
});

export default responsiveFontSizes(theme);
